<template>
    <Checkbox :value="value" class="container" @input="onInput">
        <div>
            <p class="legal-text">
                {{ config.CASTING_BRIEF_LEGAL_TEXT_1 }}
            </p>
            <p class="legal-text">
                {{ config.CASTING_BRIEF_LEGAL_TEXT_2 }}
                <a :href="legalUrl" target="_blank" rel="noreferrer">{{ config.CASTING_BRIEF_LEGAL_LINK }}</a>
            </p>
        </div>
    </Checkbox>
</template>
<script>
import { SolutionConsumer } from '@skeepers/platform-framework/mixins';

export default {
    name: 'BriefLegal',
    mixins: [SolutionConsumer],
    props: {
        value: Boolean,
    },
    computed: {
        legalUrl () {
            const url = this.config.DEPOSIT_LEGAL_PP_LINK_URL;
            return url ? `${url}${url.endsWith('/') ? '' : '/'}${this.language}` : '';
        },
    },
    methods: {
        onInput (value) {
            this.$emit('input', value);
        },
    },
};
</script>
<style lang="scss">
.container {
    margin: 1rem 0;

    .legal-text {
      font-size: 0.75rem;
      line-height: 1.5;
    }
}
</style>
